import { render, staticRenderFns } from "./TabChavesPix.vue?vue&type=template&id=76bb1716&scoped=true&"
import script from "./TabChavesPix.vue?vue&type=script&setup=true&lang=js&"
export * from "./TabChavesPix.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb1716",
  null
  
)

export default component.exports